import { UserOutlined } from "@ant-design/icons";
import { Avatar, Flex, Progress, Rate } from "antd";

export default function Rating() {
  const reviews = [
    {
      name: "Livia Herrington",
      date: "25 July, 2024",
      rating: 4,
      comment:
        "The course is well-structured and easy to follow. The instructor is knowledgeable and provides clear explanations. Highly recommended! Section 4: Auto Layout",
      extra: "Section 4: Auto Layout",
      avatar: "https://i.pravatar.cc/150?img=1",
    },
    {
      name: "Livia Herrington",
      date: "01 August, 2024",
      rating: 4,
      comment:
        "The course is well-structured and easy to follow. The instructor is knowledgeable and provides clear explanations. Highly recommended!",
      extra: "Section 4: Auto Layout",
      avatar: "https://i.pravatar.cc/150?img=2",
    },
    {
      name: "Livia Herrington",
      date: "17 August, 2024",
      rating: 4,
      comment:
        "The course is well-structured and easy to follow. The instructor is knowledgeable and provides clear explanations. Highly recommended! Section 4: Auto Layout",
      extra: "Section 4: Auto Layout",
      avatar: "https://i.pravatar.cc/150?img=3",
    },
    {
      name: "Livia Herrington",
      date: "01 August, 2024",
      rating: 4,
      comment:
        "The course is well-structured and easy to follow. The instructor is knowledgeable and provides clear explanations. Highly recommended!",
      extra: "Section 4: Auto Layout",
      avatar: "https://i.pravatar.cc/150?img=4",
    },
  ];

  const ratingDistribution = [
    { stars: 5, count: 25, percentage: 60 },
    { stars: 4, count: 20, percentage: 48 },
    { stars: 3, count: 15, percentage: 36 },
    { stars: 2, count: 10, percentage: 24 },
    { stars: 1, count: 5, percentage: 12 },
  ];

  return (
    <div className="p-5 bg-white rounded-xl shadow-[0px_3px_16px_0px_rgba(0,0,0,0.04)] border-none">
      <div className="pb-3 border-b border-theme-slate-200">
        <h6 className="text-theme-slate-800 text-2xl font-bold">
          Learners Feedback
        </h6>
        <p className="mt-1 text-slate-600 text-sm font-normal">
          4.7 course rating • 43K ratings
        </p>
      </div>

      {/* Rating Overview */}
      <div className="mb-6 pb-6 border-b border-gray-200 max-w-[800px]">
        <h3 className="text-theme-slate-800 text-lg font-medium mt-4">
          Overall Reviews
        </h3>
        <div className="flex flex-wrap items-center gap-4 lg:gap-36">
          {/* Overall Rating */}

          <Flex align="center" className="flex-col">
            <div className="text-theme-zinc-700 text-2xl lg:text-4xl font-medium">
              5.0<span className="text-base">/5</span>
            </div>
            <Rate disabled defaultValue={5} className="custom-rate" />
            <p className="text-theme-slate-600 text-xs font-normal mt-1.5">
              Based on 43K ratings
            </p>
          </Flex>

          {/* Rating Bars */}
          <div className="flex-1">
            {ratingDistribution.map((item) => (
              <Flex align="center" gap={20} key={item.stars} className="mb-2">
                <Rate
                  disabled
                  defaultValue={item.stars}
                  className="custom-rate"
                />
                <Progress
                  percent={item.percentage}
                  showInfo={false}
                  strokeColor="#FC8415"
                  trailColor="#E9EFF6"
                  className="flex-1"
                  strokeLinecap="butt"
                />
                <span className="text-theme-slate-600 text-lg font-normal w-8">
                  {item.count}
                </span>
              </Flex>
            ))}
          </div>
        </div>
      </div>

      {/* Reviews List */}
      <div className="space-y-3">
        {reviews.map((review, index) => (
          <div
            key={index}
            className="pb-3 border-b border-theme-zinc-200 last:border-0"
          >
            <Flex gap={16}>
              <Avatar size={48} src={review.avatar} icon={<UserOutlined />} />
              <div className="flex-1">
                <Flex align="center" gap={20} className="mb-1">
                  <h3 className="text-theme-slate-700 text-base lg:text-lg font-normal">
                    {review.name}
                  </h3>
                </Flex>
                <Flex
                  align="center"
                  gap={20}
                  className="text-theme-slate-500 text-sm font-normal"
                >
                  {review.date}{" "}
                  <Rate
                    disabled
                    defaultValue={review.rating}
                    className="custom-rate relative -top-1"
                  />
                </Flex>
              </div>
            </Flex>
            <p className="text-theme-slate-600 text-sm font-normal my-3">
              {review.comment}
            </p>
            <span className="text-theme-slate-600 text-xs font-normal px-2 py-1 rounded bg-slate-100">
              {review.extra}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
